import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { Control } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTitle, resetTriggerExpand } from 'actions/home_bar/scope_dropdown';
import { useHomeTabs } from 'hooks/home/tabs';
import { forceExpandTriggeredSelector, titleSelector } from 'selectors/home_bar';
const controlCss = "c1xon4mg";
const textCropCss = "t6xlwr6";
const ScopeDropdownControl = ({
  controlRef,
  className,
  ...props
}) => {
  const dispatch = useDispatch();
  const title = useSelector(titleSelector);
  const forceExpandTriggered = useSelector(forceExpandTriggeredSelector);
  const {
    getTabScopeV1
  } = useHomeTabs();
  const {
    type,
    id
  } = getTabScopeV1();
  useEffect(() => {
    dispatch(loadTitle(type, id));
  }, [dispatch, type, id]);
  useEffect(() => {
    if (!forceExpandTriggered) return;
    const control = controlRef.current;
    if (control?.getAttribute('aria-expanded') !== 'true') {
      control.click();
    }
    dispatch(resetTriggerExpand());
  }, [forceExpandTriggered, dispatch, controlRef]);
  const accessibleName = title || I18n.t('publisher.messages.loading');
  return <Control ref={controlRef} className={classNames(controlCss, className)} aria-label={accessibleName} data-calendly-label="scope-button" data-testid="scope-dropdown-control" {...props}>
      {!title ? <Loader role="status" aria-label={I18n.t('publisher.messages.loading')} /> : <BodyText className={textCropCss}>{title}</BodyText>}
    </Control>;
};
export default ScopeDropdownControl;

require("./control.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./control.js");